import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import AddLeavePopup from './AddLeavePopup';
import DashboardHeading from '../commonFiles/DashboardHeading';

class ViewLeave extends Component {
  constructor() {
    super();
    this.state = {
      all_table_row:[],
      addNewEventPopup:'',
    };
  }

formatTime(timeString) {
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
}

show_list(list){
  var status = ['Pendding','Approved','Rejected'];
  var all_table_row = [];
  if(list.length>0){
    var no =1;
    for(var i=0; i<list.length; i++){
    var list_data = list[i];
    var approved = list[i]['approved'];
    var info      = list_data['data'];
    var status_color = status[approved];
    var approved_icon = [];
    var rejected_icon = [];
    var view_icon = [];
    var leave_balance = info['leave_balance'];
      if(approved==0){
        approved_icon.push(<a className="pointer leave_icon" title="Approved"><i class="fas fa-thumbs-up"></i></a>);
        rejected_icon.push(<a className="pointer leave_icon" title="Rejected"><i class="fas fa-thumbs-down"></i></a>);
        leave_balance = '-';
      }

      view_icon.push(<a className="pointer leave_icon" title="View"><i class="fas fa-eye"></i></a>);

      all_table_row.push(<tr>
        <td>{no}</td>
        <td>{info['emp_name']}</td>
        <td>{info['leave_type']}</td>
        <td>{info['leave_from_date']+" "+this.formatTime(info['leave_from_time'])}</td>
        <td>{info['leave_to_date']+" "+this.formatTime(info['leave_to_time'])}</td>
        <td>{info['leave_count']}</td>
        <td>{leave_balance}</td>
        <td className={'color'+status_color}>{status[approved]}</td>
        <td className="text_align_center">{approved_icon}</td>
        <td className="text_align_center">{rejected_icon}</td>
        <td className="text_align_center">{view_icon}</td>
        </tr>);
        no++;
    }
  }else{
    all_table_row.push(<tr><td colspan="9">No Event</td></tr>);
  }
  this.setState({all_table_row});
}

get_all_event_list(){
  var cutThis        = this;
  var web_token     = window.isNullAndUndef($('#web_token').val());
  var body          = new FormData();
  body.append('web_token',web_token);
  body.append('function','get_all_event_data');
  var url      = '';
  if(window.location.host ==="localhost:3000"){
    url = "http://localhost/bylawsindia/php/admin_leave_manage_url.php";
  }else{
    url = "/php/admin_leave_manage_url.php";
  }
  axios({
       method: 'POST',
       url: url,
       async: false,
       data: body,
       enctype: 'multipart/form-data',
       processData: false,
       contentType: false,
       cache: false,
   })
   .then(function (res) {
      var data = res.data;
      cutThis.show_list(data);
   })
   .catch(function (error) {
       console.log(error);
   });
}


componentDidMount(){
  this.get_all_event_list();
}

schedule_consultation(){
  var addNewEventPopup = <AddLeavePopup close_popup_view={this.close_popup.bind(this)}/>;
  this.setState({addNewEventPopup});
  setTimeout(function (){window.model_show();},100);
}

close_popup(){
  window.model_hide();
  var addNewEventPopup = '';
  this.setState({addNewEventPopup});
  this.get_all_event_list();
}

  render() {
    return (
        <>
        <DashboardHeading title="Leave Management"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">Leave Management</h3>


                <div className="col-md-12 p-0">
                <div className="col-md-3 p-0 float_r">
                      <button className="btn btn-primary w-100 py-3" type="button" onClick={this.schedule_consultation.bind(this)}>Add Leave</button>
                </div>

                <table class="table">
                <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Leave Type</th>
                <th scope="col">From Date</th>
                <th scope="col">To Date</th>
                <th scope="col">Days</th>
                <th scope="col">Remaining Days</th>
                <th scope="col">Status</th>
                <th scope="col" className="text_align_center" colspan="3">Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.all_table_row}
                </tbody>
                </table>

            </div>
            {this.state.addNewEventPopup}
        </div>
        </>
    );
  }
}

export default ViewLeave;
